import styled, {css} from 'styled-components/macro';
import Icon from './Icon';
import PinNumber from './PinNumber';

const PinWrapper = styled.div`
    display:flex;
    align-items:center;
    justify-content:flex-start;
    padding:5px;
    border-radius:5px;
    transition: background .2s ease-out;
    &:hover {
        cursor:pointer;
        background-color:#F0F3F8;
    }
`

const PinLabel = styled.div`
    font-family: 'GT America', sans-serif;;
    font-style: normal;
    font-weight: 400;
    font-size: 1.8rem;
    line-height: 100%;
    color:#0C3E8D;
    margin-left:10px;   
    transition: color .2s ease-out;
    ${PinWrapper}:hover & {
        color:#0B2957;
    } 
    @media(max-width: 768px){
        font-size: 2.1rem;
    }
`

const PinContainer = styled.div`
    position:relative;
`

const PinMarker = styled.div`
    svg path {
        transition: fill .2s ease-out;
    }
    ${PinWrapper}:hover & {
        svg path {
            fill: #0C3E8D;
        }
    } 
`

// const PinNumber = styled.div`
//     position:absolute;
//     font-size:15px;
//     font-weight:700;
//     color:#fff;
//     // top:44%;
//     // left:49%;
//     // transform: translateX(-50%) translateY(-50%);
//     width: 100%;
//     height: 100%;
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     top: -1px;
//     left: 0;
//     line-height: 0;
//     text-align:center;
//     vertical-align:center;
// }
// `

const PinArrow = styled.div`
    margin-left:auto;
    svg path {
        fill:#DBE2EE;
    }
    ${PinWrapper}:hover & {
        svg path {
            fill: #0B2957;
        }
    } 
`



export default function NavPin(props){

    const handlePress = e => {
        if(e.key === 'Enter') { 
            props.handleClick(props.pinNumber)
        }
    }

    return (
        <PinWrapper onClick={()=>props.handleClick(props.pinNumber)} tabIndex={0} onKeyPress={handlePress}>
            <PinContainer>
                <PinNumber pinNumber={props.pinNumber} />
            </PinContainer>
            <PinLabel>{props.title}</PinLabel>
            <PinArrow>
                <Icon type="Arrow Right" />
            </PinArrow>
        </PinWrapper>
    )
}